// Checkout entry points over the aldoo-ra Store purchase flow "aldoo"
// (components/Store/flows/aldoo.jsx).
import { store } from "aldoo-ra/Store"
import { toCartItem } from "../checkout/cartItems"
import { track } from "../analytics"

export { isLicenseKeyProduct, isDigitalOnly, hasPhysicalItems } from "../checkout/cartItems"

/**
 * Opens the checkout. `items` = [{ product, quantity, options }] are added to
 * the cart first (direct purchase links such as /buy-book/:pid); when omitted
 * the checkout starts on the current cart.
 */
export function openCheckout(items = null) {
  // The store mounts client-side (CheckoutHost); a page effect may run first
  if (typeof store.beginCheckout !== "function") return new Promise((resolve) => setTimeout(() => resolve(openCheckout(items)), 100))
  if (!items?.length) return store.beginCheckout()
  for (const { product, quantity = 1, options } of items) {
    store.addToCart({ product: toCartItem(product, quantity, options), quantity, options })
    // a direct purchase link is a placement of its own (store/placements)
    track("ADD_TO_CART", { pid: product?.pid, placement: "buy_link", quantity, kind: "add" })
  }
  return store.beginCheckout()
}
